(() => {
  if (window.MKViewportSurfaces) return;
  const root = document.documentElement;
  const themeColor = document.getElementById('Viewport-theme-color');
  let frame = 0;
  let motionUntil = 0;
  let lastTop;
  let lastBottom;
  let lastOwner;

  function resolveViewportSurfaceColors(state) {
    if (state.search) return { top: state.search, bottom: state.search, owner: 'search' };
    if (state.cart) return { top: state.cart, bottom: state.cartFooter || state.cart, owner: 'cart' };
    if (state.navigation) return {
      top: state.navigation,
      bottom: state.subpanel || state.navigationFooter || state.navigation,
      owner: 'navigation'
    };
    return {
      top: state.announcement || state.header || state.page,
      bottom: state.bottom || state.page,
      owner: state.announcement ? 'announcement' : state.header ? 'header' : 'page'
    };
  }

  function compositeSurfaceColor(color, base) {
    const channels = color.match(/[\d.]+/g)?.map(Number) || [0, 0, 0, 0];
    const alpha = channels[3] ?? 1;
    return base.map((channel, index) => Math.round(channels[index] * alpha + channel * (1 - alpha)));
  }

  function update() {
    frame = 0;
    const mobile = window.innerWidth < 990;
    const styles = new Map();
    const styleOf = element => {
      if (!styles.has(element)) styles.set(element, getComputedStyle(element));
      return styles.get(element);
    };
    const page = styleOf(document.body).backgroundColor;
    const base = compositeSurfaceColor(page, [255, 255, 255]);
    const colorOf = element => {
      const layers = [];
      for (let node = element; node && node !== document.body && node !== root; node = node.parentElement) {
        layers.push(styleOf(node).backgroundColor);
      }
      return `rgb(${layers.reverse().reduce((color, layer) => compositeSurfaceColor(layer, color), base).join(', ')})`;
    };
    const state = { page };
    if (mobile) {
      const header = document.querySelector('#header');
      const inset = parseFloat(styleOf(root).getPropertyValue('--mk-safe-area-inset-top')) || 0;
      const coversTop = element => {
        if (!element) return false;
        const rect = element.getBoundingClientRect();
        return rect.top <= inset + 1 && rect.bottom > inset + 1;
      };
      const announcement = document.querySelector('.js-announcement-bar');
      const search = document.querySelector('.header-search-drawer__dialog[open]');
      const cart = document.querySelector('cart-drawer.is-visible .cart-drawer__inner');
      const navigation = header?.querySelector('header-drawer.mobile-drawer details[open]');
      if (search) state.search = colorOf(search);
      else if (cart) {
        state.cart = colorOf(cart);
        state.cartFooter = colorOf(cart.querySelector('.sticky-footer') || cart);
      } else if (navigation) {
        state.navigation = colorOf(header.querySelector('.header-mobile-component__inner') || header);
        const subpanel = header.querySelector('.drawer__panel.is-active');
        const footer = navigation.querySelector('.drawer__row--mobile-submenu');
        state.subpanel = subpanel ? colorOf(subpanel) : null;
        state.navigationFooter = footer ? colorOf(footer) : null;
      } else {
        state.announcement = coversTop(announcement) ? colorOf(announcement) : null;
        state.header = coversTop(header) ? colorOf(header.querySelector('.header-mobile-component__inner') || header) : null;
        const atBottom = document.elementsFromPoint(window.innerWidth / 2, window.innerHeight - 1)
          .find(element => !element.closest('.viewport-safe-areas'));
        state.bottom = colorOf(atBottom || document.body);
      }
    }
    const colors = resolveViewportSurfaceColors(state);
    if (colors.top !== lastTop) {
      root.style.setProperty('--mk-safe-area-top', colors.top);
      themeColor?.setAttribute('content', colors.top);
      lastTop = colors.top;
    }
    if (colors.bottom !== lastBottom) {
      root.style.setProperty('--mk-safe-area-bottom', colors.bottom);
      lastBottom = colors.bottom;
    }
    if (colors.owner !== lastOwner) {
      root.dataset.viewportTopSurface = colors.owner;
      lastOwner = colors.owner;
    }
    if (mobile && performance.now() < motionUntil) schedule();
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function sampleMotion() {
    motionUntil = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : performance.now() + 320;
    schedule();
  }

  const observer = new MutationObserver(sampleMotion);
  function refresh() {
    observer.disconnect();
    document.querySelectorAll('#header, .js-announcement-bar, .header-search-drawer__dialog, navigation-panels, cart-drawer')
      .forEach(element => observer.observe(element, { attributes: true, attributeFilter: ['class', 'open'] }));
    sampleMotion();
  }
  window.MKViewportSurfaces = { update: schedule };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', sampleMotion);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('shopify:section:load', refresh);
  window.addEventListener('mk:overlay-change', sampleMotion);
  refresh();
})();
